Retorna dois blocos:

- a credencial autenticada na chamada atual;
- o catálogo global de escopos reconhecidos pela plataforma.

<ApiCodeExamples exampleId="metaScopes" />

<ApiResponseExamples exampleId="metaScopes" />

## Query parameters

Este endpoint não aceita query parameters.

## Resposta `200`

### `credential`

- `credential.id` (`uuid`): identificador da credencial autenticada.
- `credential.name` (`string`): nome administrativo da credencial.
- `credential.key_id` (`string`): identificador público/indexável da credencial.
- `credential.secret_last4` (`string`): últimos 4 caracteres do segredo atual.
- `credential.scopes` (`array<string>`): escopos atualmente atribuídos à credencial.
  Valores possíveis:
  `campaigns.read`, `calls.read`, `calls.write`, `agents.read`, `scripts.read`, `users.read`, `transfer_groups.read`
- `credential.allowed_ips` (`array<string>`): allowlist efetiva de IPs, quando configurada.
- `credential.rate_limit_per_minute` (`integer`): teto de requisições por minuto para essa credencial.
- `credential.is_active` (`boolean`): indica se a credencial continua operacional.
  Valores possíveis:
  `true`, `false`
- `credential.expires_at` (`datetime|null`): data/hora de expiração da credencial. `null` significa sem expiração automática.
- `credential.last_used_at` (`datetime|null`): última vez em que a credencial foi usada com sucesso.
- `credential.last_used_ip` (`string|null`): último IP observado no uso aceito da credencial.
- `credential.created_by_name` (`string|null`): nome ou email do usuário que criou a credencial.
- `credential.revoked_by_name` (`string|null`): nome ou email do usuário que revogou a credencial, se houver.
- `credential.revoked_at` (`datetime|null`): instante da revogação, se aplicável.
- `credential.revoke_reason` (`string`): motivo de revogação registrado.
- `credential.created_at` (`datetime`): instante de criação da credencial.
- `credential.updated_at` (`datetime`): instante da última atualização persistida.

### `available_scopes`

- `available_scopes` (`array<object>`): catálogo global de escopos conhecidos pelo produto.
- `available_scopes[].code` (`string`): código canônico do escopo.
  Valores possíveis:
  `campaigns.read`, `calls.read`, `calls.write`, `agents.read`, `scripts.read`, `users.read`, `transfer_groups.read`
- `available_scopes[].label` (`string`): rótulo humano do escopo.

## Erros esperados

- `401 Unauthorized`: token inválido, expirado, revogado, ausente ou bloqueado por IP.
- `403 Forbidden`: a credencial autenticou, mas não possui o escopo exigido para a operação.
- `429 Too Many Requests`: a credencial excedeu o limite permitido na janela atual.

## Quando usar este endpoint

- verificar quais escopos a credencial atual realmente possui;
- comparar o catálogo global com os escopos já atribuídos;
- depurar `403 Forbidden` ou gaps de permissão em integrações externas.
